import React from "react";
import { Button } from "@mui/material";

const DownloadProductsButton = () => {
 const handleDownload = async () => {
  try {
   const response = await fetch(
    "https://app-api.carexpert.org.in/api/products/download-products",
   );

   if (!response.ok) throw new Error("Download failed");

   const blob = await response.blob();
   const url = window.URL.createObjectURL(blob);

   const link = document.createElement("a");
   link.href = url;
   link.download = "products.xlsx";
   document.body.appendChild(link);
   link.click();
   link.remove();
   window.URL.revokeObjectURL(url);
  } catch (err) {
   console.error("Download error:", err);
   alert("Failed to download file");
  }
 };

 return (
  <Button variant="contained" color="success" onClick={handleDownload}>
   📥 Download Product Excel
  </Button>
 );
};

export default DownloadProductsButton;
